let Style_PointNor = {
    show: true,
    pixelSize: 10,
    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
    color: Cesium.Color.TURQUOISE,
    outlineColor: Cesium.Color.YELLOW,
    outlineWidth: 2,
    //scaleByDistance:NearFarScalar,
    //translucencyByDistance:NearFarScalar,
    //distanceDisplayCondition:DistanceDisplayCondition,
    disableDepthTestDistance: Number.MAX_VALUE,
}

let Style_PointCenter = {
    show: true,
    pixelSize: 10,
    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
    color: Cesium.Color.TURQUOISE,
    outlineColor: Cesium.Color.DARKRED,
    outlineWidth: 2,
    //scaleByDistance:NearFarScalar,
    //translucencyByDistance:NearFarScalar,
    //distanceDisplayCondition:DistanceDisplayCondition,
    disableDepthTestDistance: Number.MAX_VALUE,
}

let Style_PointRotation = {
    show: true,
    pixelSize: 10,
    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
    color: Cesium.Color.TURQUOISE,
    outlineColor: Cesium.Color.DARKVIOLET,
    outlineWidth: 2,
    //scaleByDistance:NearFarScalar,
    //translucencyByDistance:NearFarScalar,
    //distanceDisplayCondition:DistanceDisplayCondition,
    disableDepthTestDistance: Number.MAX_VALUE,
}

let Style_PointHeight = {
    show: true,
    pixelSize: 10,
    heightReference: Cesium.HeightReference.NONE,
    color: Cesium.Color.TURQUOISE,
    outlineColor: Cesium.Color.LIME,
    outlineWidth: 2,
    //scaleByDistance:NearFarScalar,
    //translucencyByDistance:NearFarScalar,
    //distanceDisplayCondition:DistanceDisplayCondition,
    disableDepthTestDistance: Number.MAX_VALUE,
};

let Style_LineNor = {
    show: true,
    // positions: [],
    width: 3,
    // granularity: Cesium.Math.RADIANS_PER_DEGREE,
    material: Cesium.Color.RED,
    // // depthFailMaterial: Cesium.Color.RED,
    // arcType: Cesium.ArcType.GEODESIC, //线形
    clampToGround: true,
    // //shadows: Cesium.ShadowMode.DISABLED, //阴影、投射
    // //distanceDisplayCondition:DistanceDisplayCondition, 按照视距显示
    classificationType: Cesium.ClassificationType.BOTH,
    //zIndex:0  //实体压盖层级
}

let Style_polygonNor = {
    // clampToGround: true, //----?
    show: true,
    // hierarchy:[],
    // height: 0,//相对地球表面的高度
    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,//贴地
    //extrudedHeight: 0, //拉伸高度
    // extrudedHeightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
    // stRotation: 0,//纹理旋转角度
    // granularity: Cesium.Math.RADIANS_PER_DEGREE,
    fill: true,
    material: Cesium.Color.RED.withAlpha(0.5),
    outline: true,
    outlineColor: Cesium.Color.RED,
    outlineWidth: 2,
    perPositionHeight: false, //是否使用面自身高度
    closeTop: true,
    closeBottom: true,
    arcType: Cesium.ArcType.GEODESIC,
    shadows: Cesium.ShadowMode.DISABLED, //阴影、投射
    // //distanceDisplayCondition:DistanceDisplayCondition, 按照视距显示
    classificationType: Cesium.ClassificationType.BOTH,
    //zIndex:0  //实体压盖层级
    //textureCoordinates:Property | PolygonHierarchy //纹理坐标
}

let Style_rectangleNor = {
    show: true,
    //coordinates:Rectangle,
    //height:0,
    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,//贴地
    //extrudedHeight: 0, //拉伸高度
    // extrudedHeightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
    rotation: 0,
    stRotation: 0,
    // granularity: Cesium.Math.RADIANS_PER_DEGREE,
    fill: true,
    material: Cesium.Color.RED.withAlpha(0.5),
    outline: false,
    outlineColor: Cesium.Color.RED,
    outlineWidth: 0,
    shadows: Cesium.ShadowMode.DISABLED, //阴影、投射
    // //distanceDisplayCondition:DistanceDisplayCondition, 按照视距显示
    classificationType: Cesium.ClassificationType.BOTH,
    //zIndex:0  //实体压盖层级
}

let Style_EllipseNor = {
    show: true,
    //semiMajorAxis:,
    //semiMinorAxis:,
    //height:0,
    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,//贴地
    extrudedHeight: 0, //拉伸高度
    //extrudedHeightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
    rotation: 0,
    stRotation: 0,
    // granularity: Cesium.Math.RADIANS_PER_DEGREE,
    fill: true,
    material: Cesium.Color.RED.withAlpha(0.5),
    outline: true,
    outlineColor: Cesium.Color.RED,
    outlineWidth: 2,
    numberOfVerticalLines: 16, //分割数
    shadows: Cesium.ShadowMode.DISABLED, //阴影、投射
    // //distanceDisplayCondition:DistanceDisplayCondition, 按照视距显示
    classificationType: Cesium.ClassificationType.BOTH,
    //zIndex:0  //实体压盖层级
}

let Style_Ellipsoid = {
    show: true,
    //radii:,
    //innerRadii:,
    //minimumClock:0, 椭球角度
    //maximumClock:2*PI 椭球角度
    //minimumCone:0
    //maximumCone:PI
    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,//贴地
    fill: true,
    material: Cesium.Color.RED.withAlpha(0.5),
    outline: true,
    outlineColor: Cesium.Color.RED,
    outlineWidth: 2,
    //stackPartitions: 64, //分割数
    //slicePartitions:64,
    //subdivisions:128,
    shadows: Cesium.ShadowMode.DISABLED, //阴影、投射
    //distanceDisplayCondition:DistanceDisplayCondition, 按照视距显示
}

let Style_Cylinder = {
    show: true,
    //length:, //长度
    topRadius: 0,//顶部半径
    //bottomRadius:底部半径
    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,//贴地
    fill: true,
    material: Cesium.Color.RED.withAlpha(0.5),
    outline: true,
    outlineColor: Cesium.Color.RED,
    outlineWidth: 2,
    //numberOfVerticalLines: 16, //分割数
    //lices:128, 为4就是四棱锥
    shadows: Cesium.ShadowMode.DISABLED, //阴影、投射
    //distanceDisplayCondition:DistanceDisplayCondition, 按照视距显示
}

let Style_Wall = {
    show: true,
    //positions:, //坐标
    //minimumHeights: [],//最低高度
    //maximumHeights:[],//最高高度
    // granularity: Cesium.Math.RADIANS_PER_DEGREE,
    fill: true,
    material: Cesium.Color.RED.withAlpha(0.5),
    outline: true,
    outlineColor: Cesium.Color.RED,
    outlineWidth: 1,
    shadows: Cesium.ShadowMode.DISABLED, //阴影、投射
    //distanceDisplayCondition:DistanceDisplayCondition, 按照视距显示
}

//管道
let Style_PolylineVolume = {
    show: true,
    //positions:, //坐标
    //shape: [],//形状
    cornerType: Cesium.CornerType.ROUNDED,
    // granularity: Cesium.Math.RADIANS_PER_DEGREE,
    fill: true,
    material: Cesium.Color.RED.withAlpha(0.5),
    outline: false,
    outlineColor: Cesium.Color.RED,
    outlineWidth: 1,
    shadows: Cesium.ShadowMode.DISABLED, //阴影、投射
    //distanceDisplayCondition:DistanceDisplayCondition, 按照视距显示
}

export default {
    "point_Nor": Style_PointNor,
    "point_Center": Style_PointCenter,
    "point_Rotate": Style_PointRotation,
    "point_height": Style_PointHeight,
    "polyline_Nor": Style_LineNor,
    "bezier_Nor": Style_LineNor,
    "polygon_Nor": Style_polygonNor,
    "rectangle_NorP": Style_polygonNor,
    "rectangle_Nor": Style_rectangleNor,
    "triangle_Nor": Style_polygonNor,
    "circle_Nor": Style_EllipseNor,
    "ellipsoid_Nor": Style_Ellipsoid,
    "cylinder_Nor": Style_Cylinder,
    "wall_Nor": Style_Wall,
    "polylineVolume_Nor": Style_PolylineVolume
}